if (".in-index".length) {
  var storredNews = sessionStorage.getItem(document.location.hostname + "-storredNewsData");
  sessionStorage.removeItem(document.location.hostname + "-storredNewsData"); // Odstranění uložených dat po načtení stránky
  if (storredNews) {
    var storredNews = JSON.parse(storredNews);
    $(".blogWrapper .news-wrapper").html(storredNews);
  } else {
    $.ajax({
      url: "/blog/",
      type: "GET",
      success: function (response) {
        var content = $(response);
        var newsItems = content.find(".news-item").slice(0, 3);
        var combinedHtml = "";
        newsItems.each(function (index, element) {
          var $element = $(element);
          var $elementImage = $element.find(".image img").attr("data-src") || $element.find(".image img").attr("src");
          var $elementTitle = $element.find(".title").text().trim();
          var $elementCreated = $element.find("time").text().trim();
          var $elementLink = $element.find(".title").attr("href");
          var $elementDescription = $element.find(".description").html();
          combinedHtml += `
                    <div class="news-item">
                        <div class="image">
                            <a href="${$elementLink}" class="title">
                                <img src="${$elementImage}">
                            </a>
                        </div>
                        <a href="${$elementLink}" class="text">
                            <span class="tms title">${$elementTitle}</span>
                            <div class="description">${$elementDescription}</div>
                        </a>
                        <a class="noBtn btn-arrow" href="${$elementLink}">Číst více</a>
                    </div>
                `;
        });
        $(".blogWrapper .news-wrapper").html(combinedHtml);
        sessionStorage.setItem(document.location.hostname + "-storredNewsData", JSON.stringify(combinedHtml));
      },
      error: function (xhr, status, error) {
        console.error("Error fetching news data:", status, error);
      },
    }).done(function () { });
  }
}





if ($('#newsWrapper').length) {
  $('#newsWrapper .news-item').each(function () {
    var $newsItem = $(this);
    var detailLink = $newsItem.find('a.title').first().attr('href');

    if (detailLink && !$newsItem.find('a.noBtn.btn-arrow').length) {
      $('<a>', {
        class: 'noBtn btn-arrow',
        href: detailLink,
        text: 'Číst více',
      }).appendTo($newsItem);
    }
  });
}